module.exports = __webpack_public_path__ + "static/img/001.65c8950a.png";